<template>
    <div id="CreateSlUser" class="starter-template" v-if="userName">
        <b-container>
            <br>
            <h4 class="text-center">{{this.$t('WELCOME_TO')}}</h4>
            <h4 class="text-center primary">{{userFirstName}} {{userLastName}}</h4>
            <h4 class="text-center">
                {{this.$t('NEXT_LOG_STEP1')}}
                <span class="primary">{{userName}}</span>
                {{this.$t('NEXT_LOG_STEP2')}}
            </h4>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-row align-h="center">
                    <b-col cols="12">
                        <br><br>
                        <h4>{{this.$t('LOGIN1')}}</h4>
                        <b-form-group>
                            <b-form-input
                                v-model.trim="$v.userName.$model"
                                :state="validateState('userName')"
                                aria-described-by="input-1"
                                :placeholder="userName"
                                size="md"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-1"
                            ><h5>{{this.$t('R_NAME')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <br>
                        <b-button variant="link" @click="$bvModal.show('modal-1')"><h4>{{this.$t('TMS_ACC')}}<span class="redC">*</span></h4></b-button>
                        <br>
                        <b-form-group>
                            <b-form-checkbox
                                    size="lg"
                                    v-model="$v.status.$model"
                                    required
                                    name="input-6"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                            >
                                <b-button type="submit" class="text-center">
                                    {{this.$t('ENTER')}}
                                </b-button>
                            </b-form-checkbox>
                        </b-form-group>

                    </b-col>
                </b-form-row>
            </b-form>
        </b-container>

        <b-modal id="modal-1" size="xl">
            <span v-html="terms"></span>
            <template v-slot:modal-footer>
                <b-button @click="accept()">
                    {{ $t("ACCEPT")}}
                </b-button>
                <b-button @click="close()">
                    {{$t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>

        <b-container fluid class="footer text-center">
            <b-button class="m-1" @click="$showDoc('About')">{{$t('ABOUT')}}</b-button>
            <b-button class="m-1" @click="$showDoc('Terms')">{{$t('TERMS')}}</b-button>
            <b-button class="m-1" @click="$showDoc('Privacy')">{{$t('PRIVACY')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>
</template>

<script>
import { BContainer, BCol, BForm, BFormRow, BFormGroup, BFormInput, BFormCheckbox,
    BButton, BFormInvalidFeedback, BModal } from 'bootstrap-vue';
import { validationMixin } from "vuelidate";
import { helpers, required, minLength, maxLength } from 'vuelidate/lib/validators';
import Help from "./Help.vue";
import {Cnst} from '@/plugins/Cnst.js';

const itemNameR = helpers.regex('itemNameR',/^(?!.*?[-\s]{2})[a-zA-Z.\-а-яА-ЯёЁ\s]+$/);

export default {
  name: 'CreateSlUser',
  components: {
    Help,
    BContainer, BCol, BForm, BFormRow, BFormGroup, BFormInput, BFormCheckbox,
    BButton, BFormInvalidFeedback, BModal
  },
  mixins: [validationMixin],
  data: function() {
    return {
      userName: '',
      userFirstName: '',
      userLastName: '',
      status: '',
      terms: '',
      helpName: 'HelpCreateSlUser',
      showHelp: false,
      intLoc: this.$i18n.locale
    }
  },
  beforeMount() {
    //this.userName = this.$store.state.curUserName;
    this.userName = this.$rmEncHyp(this.$route.query.userName);
    if(typeof this.userName === 'undefined' || this.userName === '') {
        this.$serveErr('CreateSlUser: mounted() user is undefined or empty');
        this.deny();
    }
    this.userFirstName = this.$rmEncHyp(this.$route.query.userFirstName);
    this.userLastName = this.$rmEncHyp(this.$route.query.userLastName);
  },
  mounted() {
    this.getTerms();
  },
  methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    },
    async getTerms() {
        try {
            const response = await this.$http.get('/getDoc', {
                params: {
                    title: 'Terms',
                    locale: this.intLoc
                }
            });
            this.terms = response.data;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async onSubmit() {
        this.$v.$touch();
        if(this.$v.$anyError) return;
        try {
            const response = await this.$http.get('/addSlUser', {
                params: { userName: this.userName }
            });
            let userName = await response.data;
            this.$store.commit('setCurUserName', userName);
            this.$router.push({
                path: '/Map/UserMap/_/'+this.$addEncHyp(userName),
                query: {
                    published: true,
                    blocked: false,
                }
            });
         } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('CreateSlUser: onSubmit() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
            this.deny();
        }
    },
/*
    showTerms() {
        this.$bvModal.show('modal-1');
    },
*/
    accept() {
        this.status='accepted';
        this.$store.commit('setAccept', 'accepted');
        this.$bvModal.hide('modal-1');
    },
    deny() {
        this.status='';
        this.$store.commit('setAccept', '');
        this.$store.commit('setCurUserName', '');
        //window.location = location.protocol+'//'+location.host;
        this.$router.push({ path: '/' });
    },
    close() {
        this.$bvModal.hide('modal-1');
    }
  },
  validations: {
      userName: {
          required,
          itemNameR,
          minLength: minLength(2),
          maxLength: maxLength(Cnst.MAX_NAME_SIZE)
      },
        status: {
            required
        }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getTerms();
    }
  }
}

</script>

<style scoped>
>>> h5{
    color: red;
    font-size: 1.2em;
}
.redC{
    color: red;
}
.primary{
    color: #0b6478;
}
.pl2em{
    padding-left: 2em;
}

.file-input {
  display: none;
}

</style>

